<template>
  <div>
    <Header :title="'创建讣告'" />
    <div class="container">
      <div class="header-top">
        <div class="title">{{ groupName }}</div>
        <div class="add-btn" @click="doAdd">
          <i class="iconfont">&#xe7b0;</i>
          <span>添加</span>
        </div>
      </div>
      <div class="list-input">
        <div v-for="(item, index) of list" :key="index" class="item">
          <div class="relation-input">
            <nut-textinput
              v-model="item.relation"
              placeholder="关系"
              :clear-btn="false"
              :disabled="false"
            />
          </div>
          <div class="name-input">
            <nut-textinput
              v-model="item.name"
              placeholder="请输入姓名"
              :clear-btn="false"
              :disabled="false"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="submit-wrap">
      <div class="btn btn-back" @click="goBack">返回</div>
      <div class="btn btn-true" @click="doEditSure">确定</div>
    </div>
  </div>
</template>

<script>
import Storage from '@/utils/storage'
import Header from '@/components/Header/Index'
export default {
  name: 'SignGroupEdit',
  components: {
    Header
  },
  data() {
    return {
      groupName: '',
      list: []
    }
  },
  mounted() {
    if (Storage.localGet('curSignGroupEditInfo')) {
      const obj = Storage.localGet('curSignGroupEditInfo')
      this.list = obj.info
      console.log(this.list)
      this.groupName = '第' + (obj.index + 1) + '组'
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    doAdd() {
      this.list.push({ relation: '', name: '' })
    },
    doEditSure() {
      const arr = this.list.filter(item => item.relation && item.name)
      const obj = Storage.localGet('curSignGroupEditInfo')
      obj.info = arr
      Storage.localSet('curSignGroupEditInfo', obj)
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  margin: 24px 15px 15px;
  padding-bottom: 65px;
  .header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .title {
      font-weight: bold;
    }
    .add-btn {
      color: #d08d04;
      display: flex;
      align-items: center;
      i {
        margin-right: 3px;
      }
    }
  }
  .list-input {
    .item {
      display: flex;
      margin-bottom: 10px;
      .relation-input {
        width: 32%;
        margin-right: 10px;
      }
      .name-input {
        flex: 1;
      }
      ::v-deep .nut-textinput input {
        width: 100%;
        border: none;
        box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.2);
      }
    }
  }
}
.submit-wrap {
  position: fixed;
  z-index: 50;
  left: 15px;
  right: 15px;
  bottom: 15px;
  display: flex;
  justify-content: space-between;
  .btn {
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    font-size: 17px;
    letter-spacing: 2px;
    flex: 1;
    text-align: center;
  }
  .btn-back {
    margin-right: 10px;
    background: #fff;
    color: #f3a914;
    box-shadow: 0px 0px 10px rgba(220, 220, 220, 0.5);
  }
  .btn-true {
    background: linear-gradient(to right, #f2a612, #f7c827);
    color: #fff;
  }
}
</style>
